import Vue from 'vue'
import { mapGetters } from 'vuex'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Maintenance from '@/components/Maintenance.vue'

export function mainLayout (PageComponent, isShowLogo = false) {
  return Vue.extend({
    inheritAttrs: false,
    components: {
      PageComponent,
      Header,
      Footer,
      Maintenance
    },
    render () {
      return (
        <div id="app" class={this.class}>
          {
            this.isMaintenance ? <Maintenance /> : <div>
              <Header isShowLogo={isShowLogo} />
              <PageComponent propsData={this.$attrs} />
              <Footer />
            </div>
          }
        </div>
      )
    },
    data () {
      return {
        isChangeFontScale: ((sessionStorage.getItem('isChangeFontScale') || 'false') === 'true')
      }
    },
    computed: {
      ...mapGetters([
        'fontScale',
        'maintenance'
      ]),
      class () {
        let c = ''
        if (this.isChangeFontScale) {
          c += ' fs-b'
        }
        return c
      },
      isMaintenance () {
        return this.maintenance.status === 'on'
      }
    },
    watch: {
      fontScale: function (value, old) {
        this.isChangeFontScale = value
      }
    }
  })
}
